module.exports = __webpack_public_path__ + "static/media/Simon-Edvardsson-resume-website.54c371eb.jpg";